@if (newsList?.length > 0) {
	<div class="navigation-block">
		<div class="d-flex justify-content-between navigation-block-header">
			<div>
				{{ 'catalog-view.news.title' | translate }}
			</div>
			<div class="d-flex">
				<div
					[class.cursor-pointer]="!isMobile"
					(click)="openNewsList()"
					[ngbTooltip]="!isMobile ? ('catalog-view.news.open-overview' | translate) : undefined">
					<img src="/assets/orca/catalogNews/news.svg" alt="{{ 'catalog-view.news.title' | translate }}" width="20" height="20" />
				</div>
				<app-collapse-filter (collapse)="collapse($event)"></app-collapse-filter>
			</div>
		</div>
		<div [class.filter-collapsed]="collapsed" class="navigation-block-body pt-2">
			<ul class="p-0 m-0">
				@for (newsItem of newsList; track newsItem) {
					<li
						class="list-group-item cursor-pointer list-group-item-action position-relative d-flex p-0 border-white mb-4"
						data-toggle="list"
						(click)="openNews.emit(newsItem.id)">
						<div [class.seen]="seenItems.includes(newsItem.id)" class="point position-absolute"></div>
						<div class="d-flex text-dark">
							<img
								[src]="newsItem?.imageUrl"
								loading="lazy"
								style="height: 38.25px; width: 34px; object-fit: scale-down"
								lazyload="1"
								onError="this.src='assets/material/no_photo.svg'"
								[alt]="newsItem?.title" />
							<div class="ps-2 flex-grow-1">
								<div class="d-flex justify-content-between me-3 pe-1">
									<div class="two-lines">{{ newsItem?.title }}</div>
								</div>
							</div>
						</div>
						<div class="app-link-dark text-small position-absolute more-position">
							{{ 'catalog-view.news.read-more' | translate }}
						</div>
					</li>
				}
			</ul>
		</div>
		<div class="pb-4"></div>
	</div>
}
